import React, { Component } from 'react'
import PropTypes from 'prop-types'
import t from 'tcomb-form'
import { Button } from '@material-ui/core'
import SettingsIcon from '@material-ui/icons/Settings'
import I18n from '../../../i18n/i18n'
import ContentCard from '../../UI/ContentCards/ContentCard'
import FormCard from '../../UI/ContentCards/FormCard'
import AppTitle from '../../UI/Texts/AppTitle'
import AppText from '../../UI/Texts/AppText'
import { Colors, Fonts, Images, Metrics } from '../../../Themes'
import connectionsStyles from '../../Styles/Screens/Connections'
import connectionStyles from '../../Styles/Screens/Connection'
import headerStyles from '../../Styles/UI/Connections/Header'

export default class Admin extends Component {

  static propTypes = {
    options: PropTypes.array.isRequired,
    activeOption: PropTypes.string.isRequired,
    onSelectOption: PropTypes.func.isRequired,
    fetching: PropTypes.bool,
    onSubmitStripeKey: PropTypes.func
  }

  static defaultProps = {
    options: [],
    activeOption: 'config',
    onSelectOption: null,
    fetching: false,
    onSubmitStripeKey: null
  }

  constructor(props) {
    super(props)
    this.state = {
      stripeKeyValue: { secretKey: '' }
    }
  }

  renderOptionItem = (option, index) => {
    const { key, label, icon } = option
    const isActive = this.props.activeOption === key
    return (
      <Button
        key={'admin-option-' + key}
        onClick={() => this.props.onSelectOption(key)}
        variant="contained"
        style={Object.assign({}, styles.optionCard, isActive ? styles.optionCardActive : {})}
      >
        <div style={styles.optionContent}>
          {icon === 'settings' && <SettingsIcon style={styles.optionIcon} />}
          <AppText text={label} customStyle={styles.optionTitle} />
        </div>
      </Button>
    )
  }

  renderOptions = () => {
    return (
      <div style={connectionsStyles.container}>
        <ContentCard
          title={I18n.t('screens.admin.title')}
          renderContentBeforeTitle={() => (
            <a href="https://raixer.com/" target="_blank" rel="noopener noreferrer">
              <img src={Images.logo} alt="Raixer" style={connectionsStyles.logo} />
            </a>
          )}
          renderContent={() => (
            <div style={connectionsStyles.connectionListWrapper}>
              <div style={connectionsStyles.connectionList}>
                {this.props.options.map((opt, i) => this.renderOptionItem(opt, i))}
              </div>
            </div>
          )}
          customStyle={{ margin: 0, background: 'none', borderWidth: 0, overflow: 'auto' }}
          customTitleAndEditContainerStyle={connectionsStyles.titleAndEditContainer}
          customContentStyle={{ padding: 0 }}
        />
      </div>
    )
  }

  onStripeKeyFormChange = (value) => {
    this.setState({ stripeKeyValue: value })
  }

  onStripeKeyFormSubmit = () => {
    const { secretKey } = this.state.stripeKeyValue
    if (secretKey && this.props.onSubmitStripeKey) {
      this.props.onSubmitStripeKey(secretKey)
      this.setState({ stripeKeyValue: { secretKey: '' } })
    }
  }

  renderConfigContent = () => {
    return (
      <div style={{ marginTop: Metrics.doubleBaseMargin }}>
        <FormCard
          title={I18n.t('screens.admin.stripeConfigTitle')}
          description={I18n.t('screens.admin.stripeConfigDescription')}
          fields={{ secretKey: t.String }}
          fieldsOptions={{
            secretKey: {
              label: I18n.t('screens.admin.stripeSecretKeyLabel'),
              type: 'password'
            }
          }}
          value={this.state.stripeKeyValue}
          onChange={this.onStripeKeyFormChange}
          onSubmit={this.onStripeKeyFormSubmit}
          fetching={this.props.fetching}
          deleteButton={false}
          submitText={I18n.t('screens.admin.stripeConfigSubmit')}
          submitIcon="save"
        />
      </div>
    )
  }

  renderContent = () => {
    const selectedOption = this.props.options.find(o => o.key === this.props.activeOption)
    const title = selectedOption ? selectedOption.label : ''

    return (
      <div style={connectionStyles.wrapper}>
        <div style={connectionStyles.container}>
          <div style={headerStyles.header}>
            <div style={{ maxWidth: '550px', flex: 1 }}>
              <div style={headerStyles.titleAndRefreshContainer}>
                <div style={headerStyles.titleContainer}>
                  <AppTitle text={title} customStyle={headerStyles.headerTitleText} />
                </div>
              </div>
              <div style={headerStyles.headerEmptySpace} />
            </div>
          </div>
          <div style={connectionStyles.mainBody}>
            <div style={{ maxWidth: '550px', flex: 1, overflow: 'visible' }}>
              <div style={connectionStyles.mainBodyScroll}>
                {this.props.activeOption === 'config' && this.renderConfigContent()}
              </div>
            </div>
          </div>
        </div>
      </div>
    )
  }

  render = () => {
    return (
      <div style={styles.container}>
        {this.renderOptions()}
        {this.renderContent()}
      </div>
    )
  }
}

const styles = {
  container: {
    display: 'flex',
    flexDirection: 'row',
    justifyContent: 'center',
    alignItems: 'center',
    flex: 1,
    height: '100vh'
  },
  optionCard: {
    marginBottom: Metrics.doubleBaseMargin,
    backgroundColor: Colors.cardBackground,
    borderRadius: Metrics.baseMargin,
    padding: 0,
    minHeight: '72px',
    width: '100%'
  },
  optionCardActive: {
    backgroundColor: Colors.lighterGray
  },
  optionContent: {
    padding: Metrics.baseMarginPlus,
    display: 'flex',
    flexDirection: 'row',
    alignItems: 'center',
    flex: 1,
    width: '100%'
  },
  optionIcon: {
    color: Colors.theme1,
    fontSize: Metrics.icons.large
  },
  optionTitle: {
    color: Colors.darkGray,
    fontSize: Fonts.size.regular,
    marginTop: 0,
    marginBottom: 0,
    marginLeft: Metrics.doubleBaseMarginPlus,
    textAlign: 'left',
    fontFamily: Fonts.type.bold
  }
}
